import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    Strikethrough as StrikethroughLucideIcon,
    AlignCenter as AlignCenterLucideIcon,
    ListOrdered as ListOrderedLucideIcon,
    AlignRight as AlignRightLucideIcon,
    AlignLeft as AlignLeftLucideIcon,
    Underline as UnderlineLucideIcon,
    Italic as ItalicLucideIcon,
    Undo2 as Undo2LucideIcon,
    Redo2 as Redo2LucideIcon,
    Quote as QuoteLucideIcon,
    Image as ImageLucideIcon,
    Link as LinkLucideIcon,
    Code as CodeLucideIcon,
    Bold as BoldLucideIcon,
    List as ListLucideIcon,
    type LucideIcon
} from "lucide-react-native";

const createToolbarIcon = (Icon: LucideIcon): NCoreUIKitIcon => ({
    customColor,
    size
}) => <Icon
    color={customColor}
    size={size}
/>;

export const StrikethroughIcon = createToolbarIcon(StrikethroughLucideIcon);

export const ListOrderedIcon = createToolbarIcon(ListOrderedLucideIcon);

export const UnderlineIcon = createToolbarIcon(UnderlineLucideIcon);

export const ItalicIcon = createToolbarIcon(ItalicLucideIcon);

export const Undo2Icon = createToolbarIcon(Undo2LucideIcon);

export const Redo2Icon = createToolbarIcon(Redo2LucideIcon);

export const LinkIcon = createToolbarIcon(LinkLucideIcon);

export const CodeIcon = createToolbarIcon(CodeLucideIcon);

export const BoldIcon = createToolbarIcon(BoldLucideIcon);

export const ListIcon = createToolbarIcon(ListLucideIcon);

export const QuoteIcon = createToolbarIcon(QuoteLucideIcon);

export const ImageIcon = createToolbarIcon(ImageLucideIcon);

export const AlignLeftIcon = createToolbarIcon(AlignLeftLucideIcon);

export const AlignCenterIcon = createToolbarIcon(AlignCenterLucideIcon);

export const AlignRightIcon = createToolbarIcon(AlignRightLucideIcon);
